export class FetchUserPageLength {
  static readonly type = '[number] Fetch All';

  constructor(public payload: number) {
  }
}
